// extracted by mini-css-extract-plugin
export var locationsContainer = "_z4-2";
export var locationsTextContainer = "_z4-1";
export var mapContainer = "_z4-0";